var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rapi-doc',{staticStyle:{"height":"100vh","width":"100%"},attrs:{"spec-url":"https://p2m.cert.orangecyberdefense.com/api/v1/swagger","render-style":"read"}})}
var staticRenderFns = []

export { render, staticRenderFns }